<div class="flxClmn bs-enabled">
	<div class="page-title-container flex-row">
		<div class="flex-column justify-content-center f-1-0">
			<div class="page-title-inner-container">
				<span class="page-title">Email Trace</span>
			</div>
			<div class="page-subtitle-container">
				<span class="page-subtitle">Follow each email through Trustifi - received, rejected or delivered, and every action taken on it (<b>last 30 days</b>)</span>
			</div>
		</div>
	</div>

	<div class="page-inner-content-holder no-scroll flex-column">
		<div class="flxClmn vSpace2 f-1-0">
			<!--query-->
			<ng-template #queryEl>
				<div class="flxRow" (ngInit)="showQueryModal = false;" style="align-items: flex-end; max-width: 500px;">
					<div class="flxRow" style="flex: 1 0; border: solid 1px var(--ui-border-strong); border-radius: var(--ui-radius-sm); overflow: visible; position: relative; min-width: 460px; height: 32px;"
						 [ngStyle]="{'border-color' : isQueryError ? 'red' : 'var(--ui-border-strong)'}">
						<div class="flxRow hSpace05" style="align-items: center; padding: 10px; border-right: solid 1px var(--ui-border-strong); cursor: pointer; border-radius: var(--ui-radius-sm) 0 0 var(--ui-radius-sm);"
							 (click)="showQueryModal = !showQueryModal"
							 [ngStyle]="{'background' : showQueryModal ? '#f7f7f7' : 'white'}">
							<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 22px; height: 22px; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M881.4 250.9H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h739.9c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM272.1 454H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5S296 454 272.1 454zM272.1 657.1H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM853.8 847.5L715.3 709c-16.9-16.9-16.9-44.6 0-61.5s44.6-16.9 61.5 0L915.3 786c16.9 16.9 16.9 44.6 0 61.5s-44.6 16.9-61.5 0zM467.9 860.2H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h326.4c23.9 0 43.5 19.6 43.5 43.5 0.1 23.9-19.5 43.5-43.5 43.5z"/><path d="M619.4 290.5C493.3 290.5 391 392.8 391 519s102.3 228.5 228.5 228.5S847.9 645.2 847.9 519 745.6 290.5 619.4 290.5z m0 388.4c-88.3 0-159.9-71.6-159.9-159.9 0-88.3 71.6-159.9 159.9-159.9s160 71.5 160 159.9c0 88.3-71.6 159.9-160 159.9z"/></svg>
							<i class="far fa-chevron-down" style="font-size: smaller;"></i>
						</div>

						<div class="flxRow hSpace1 animated fadeIn hvr-shadow" style="flex: 1 0; align-items: center; padding: 0 10px; cursor: pointer;"
							 (click)="showQueryModal = !showQueryModal">
							<a class="diamond-indent" style="font-weight: bold; height: auto; position: relative; padding-left: 12px; text-transform: capitalize;"
							   *ngFor="let query of tracingQueryDisplay"
							   tooltip="{{query.tooltip}}">
								{{query.title}}
							</a>
						</div>

						<!--query modal-->
						<div class="" style="position: absolute; bottom: -3px; transform: translateY(100%); line-height: 15px; left: 0; background: white; border: solid 1px var(--ui-border); border-radius: var(--ui-radius-md); box-shadow: var(--ui-shadow-lg); min-width: 537px;"
							 *ngIf="showQueryModal">
							<div class="flxClmn vSpace2" style="padding: 20px;">
								<div class="flxClmn vSpace2" style="padding-left: 15px; flex: 1 0;">
									<div class="flxRow hSpace1" style="align-items: center;">
										<label class="radio-container" style="display: block; width: fit-content; height: 18px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
											<input type="radio" name="byLastEmails" [value]="queryTypes.lastEmails"
												   [(ngModel)]="queryType"
												   [checked]="queryType === queryTypes.lastEmails"
												   (change)="queryValidationErrors = [];">
											<span class="checkmark"></span>
										</label>
										<div class="flxRow gap-4 f-1-0" style="align-items: center; padding-left: 15px; position: relative;"
											 [ngStyle]="queryType !== queryTypes.lastEmails ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}"
											 (click)="queryType = queryTypes.lastEmails">
											<span style="font-weight: bold; flex-basis: 100px;">Last Emails</span>
										</div>
									</div>
									<hr/>
									<div class="flxRow hSpace1" style="align-items: flex-start;">
										<label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
											<input type="radio" name="byPeriod" [value]="queryTypes.period"
												   [(ngModel)]="queryType"
												   [checked]="queryType === queryTypes.period"
												   (change)="queryValidationErrors = [];">
											<span class="checkmark"></span>
										</label>
										<div class="flxRow" style="width: 100%; padding-left: 15px;"
											 (click)="queryType = queryTypes.period"
											 [ngStyle]="queryType !== queryTypes.period ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}">
											<span style="font-weight: bold; flex-basis: 95px; padding-top: 5px; flex-shrink: 0;">Date:</span>
											<div class="flxClmn" style="margin-left: 0; flex: 1 0;">
												<app-dropdown-c class="capitalize-box" style="height: 27px; min-height: 27px; flex: 1 0; max-width: 285px;"
																[isDisabled]="queryType !== queryTypes.period"
																[ngStyle]="{'margin-bottom' : tracingQuery.period.value === dic.CONSTANTS.trendsPeriod.range.value ? '10px' : '0'}"
																text="{{tracingQuery.period.display}}">
													<li *ngFor="let periodObj of searchPeriods"
														(click)="tracingQuery.period = periodObj;">
														{{periodObj.display}}
													</li>
												</app-dropdown-c>

												<div class="flxRow hSpace1" style="align-items: center;" *ngIf="tracingQuery.period.value === dic.CONSTANTS.trendsPeriod.range.value">
													<div class="flxRow hSpace05 f-1-0" style="align-items: center;">
														<span>Date Range:</span>
														<date-picker-c class="f-1-0"
																	   [(dateModel)]="tracingQuery.range"
																	   [isRange]="true"
																	   [dateFormat]="'mm/dd/yyyy'">
														</date-picker-c>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="flxClmn vSpace2"
										 [ngStyle]="queryType !== queryTypes.period ? {'opacity' : '0.5', 'pointer-events': 'none'} : {'opacity' : '1' , 'cursor' : 'default'}">
										<div class="flxRow hSpace3" style="align-items: center; position: relative;">
											<span style="font-weight: bold; flex-basis: 100px;">Sender:</span>
											<input type="text" style="margin: 0; flex: 1 0; max-width: 285px; height: 27px;"
												   (keyup.enter)="applyQuery();"
												   placeholder="email or domain"
												   [(ngModel)]="tracingQuery.from">
										</div>
										<div class="flxRow hSpace3" style="align-items: center; position: relative;">
											<span style="font-weight: bold; flex-basis: 100px;">Recipient:</span>
											<input type="text" style="margin: 0; flex: 1 0; max-width: 285px; height: 27px;"
												   (keyup.enter)="applyQuery();"
												   placeholder="email or domain"
												   [(ngModel)]="tracingQuery.rcptTo">
										</div>
										<div class="flxRow hSpace3" style="align-items: center; position: relative;">
											<span style="font-weight: bold; flex-basis: 100px;">Subject:</span>
											<input type="text" style="margin: 0; flex: 1 0; max-width: 285px; height: 27px;"
												   (keyup.enter)="applyQuery();"
												   placeholder='use "quotes" for exact match'
												   [(ngModel)]="tracingQuery.subject">
										</div>
										<div class="flxRow hSpace3" style="align-items: center; position: relative;">
											<span style="font-weight: bold; flex-basis: 100px;">Message ID:</span>
											<input type="text" style="margin: 0; flex: 1 0; max-width: 285px; height: 27px;"
												   (keyup.enter)="applyQuery();"
												   placeholder="exact message ID"
												   [(ngModel)]="tracingQuery.message_id">
										</div>
										<div class="flxRow hSpace3" style="align-items: center; position: relative;">
											<span style="font-weight: bold; flex-basis: 100px;">Status:</span>
											<app-dropdown-c class="f-1-0 w-ellipsis" style="margin: 0; flex: 1 0; max-width: 285px; height: 27px;"
												[items]="statusQuery" itemDisplayKey="display"
												[isMultipleSelection]="true">
											</app-dropdown-c>
										</div>
									</div>
								</div>

								<div class="flxRow" style="align-items: center; justify-content: space-between;">
									<span style="color: darkred;">{{tracingQueryError}}</span>

									<div class="flxRow" style="gap: 8px;">
										<btn-c variant="text" style="height: 32px;"
											   btnTooltip="Reset all query fields" (action)="resetQuery();">
											Reset
										</btn-c>
										<btn-c style="height: 32px;"
											   [loading]="getEmailTracingInProcess"
											   (action)="applyQuery();">
											Search
										</btn-c>
									</div>
								</div>

							</div>
						</div>
					</div>

					<btn-c class="connected-to-left" style="align-self: flex-end; height: 32px; margin-left: -6px; z-index: 3;"
						   [loading]="getEmailTracingInProcess"
						   (action)="applyQuery();">
						Search
					</btn-c>

					<!--abort loading label-->
					<span class="flxClmn-center animated fadeIn" style="align-self: flex-end; cursor: pointer; padding: 0 6px 5px; background: white; font-weight: 300; color: #85000d; font-size: 0.75rem;"
						  *ngIf="showAbortLoadingEmailsLabel"
						  (click)="abortLoadingEmails()">
						<b>Abort</b>
					</span>
				</div>
			</ng-template>

			<trustifi-table-c
				class="trustifi-table" style="flex: 1 0; z-index: 5; --table-filter-min-width: 500px;"
				#emailTraceTableEl
				[list]="tracingData"
				[headers]="_.compact([
					{text: '', width: '40px'},
					{text: 'Date', sortKey: 'created', width: '160px'},
					!logsScope && {text: '', width: '30px'},
					{html: 'senderHeader', sortKey: 'from'},
					{html: 'subjectHeader', sortKey: 'subject'},
					{html: 'recipientHeader', sortKey: 'rcptTo'},
					{html: 'messageIdHeader'},
					{text: 'Status', sortKey: 'status', width: '80px', centered: true},
				])"
				[cellsPrototype]="_.compact([
					{html: 'showLogsCell'},
					{html: 'createdCell', textType: 'dateAndTime'},
					!logsScope && {html: 'directionCell'},
					{html: 'senderCell'},
					{html: 'subjectCell'},
					{html: 'recipientCell'},
					{html: 'messageIdCell'},
					{html: 'statusCell'},
				])"
				[bulkActions]="{
					enable: true,
					selectBulkActionCb:	selectEmailBulkAction,
					initBulkActionsFunction: showEmailBulkActions,
				}"
				[cellActions]="{
					enable: true,
					selectItemActionCb:	selectEmailAction,
					initActionsFunction: showEmailActions,
				}"
				(searchFunction)="searchTraceLog($event.searchTerm, $event.activeFilters)"
				[filterData]="filterEmailTraceData"
				(onAnyItemSelected)="!$event.isItemSelectCheckboxClicked && showLogsAction($event.item)"
				[options]="{
					exportToCsvFunction: exportEmailTraceCsv,
					autoRefreshFunction: getEmailTracing,
					soloSelected: true,
					loadingTableFlag: getEmailTracingInProcess,
					itemsNameSingular: 'email',
					defaultSortKey: '-created',
					emptyStateMessage: 'Create a search query and click on <b>Search</b> to show the results. If no emails appear, refine your filters and try again'
				}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<!--"show logs" cell-->
					<div *ngIf="cellId === 'showLogsCell'">
						<i class="far fa-angle-right" style="transition: 0.2s;" [ngStyle]="{'transform': item.isExpanded ? 'rotate(90deg)' : 'none'}"></i>
					</div>

					<div *ngIf="cellId === 'createdCell'" class="flxRow hSpace05" style="align-items: center;">
						<span>{{item.created | date: 'MM/dd/yyyy HH:mm'}}</span>
					</div>

					<!--sender cell-->
					<div *ngIf="cellId === 'senderCell'" class="flxRow hSpace05" style="align-items: center;">
						<a class="hvr-underline ellipsis" style="display: block;"
						   (click)="setSenderAsFilter(item.from); $event.stopPropagation();">
							{{item.from}}
						</a>
					</div>

					<!--subject cell-->
					<div *ngIf="cellId === 'subjectCell'" class="flxRow hSpace05" style="align-items: center;">
						<a class="hvr-underline ellipsis" style="display: block;"
						   [ngStyle]="{'color': item.subject ? 'black' : '#808080'}"
						   [tooltip]="item.subject"
						   (click)="item.subject && setSubjectAsFilter(item.subject); $event.stopPropagation();">
							{{item.subject || 'None'}}
						</a>
					</div>

					<!--recipient cell-->
					<div *ngIf="cellId === 'recipientCell'" class="flxRow hSpace05" style="align-items: center;">
						<a class="hvr-underline ellipsis" style="display: block;"
						   (click)="setRecipientAsFilter(item.rcptTo); $event.stopPropagation();">
							{{item.rcptTo}}
						</a>
					</div>

					<!--message ID cells-->
					<div *ngIf="cellId === 'messageIdCell'" class="flxRow hSpace05" style="padding-right: 20px; align-items: center;">
						<a class="hvr-underline" style="display: block; word-break: break-word;"
						   (click)="setMessageIdAsFilter(item.message_id); $event.stopPropagation();">
							{{item.message_id}}
						</a>
						<i class="far fa-copy copy-link hvr-opacity" tooltip="Copy message ID" (click)="copyToClipboard(item.message_id); $event.stopPropagation();"></i>
					</div>

					<!--direction (incoming/outgoing) cells-->
					<span *ngIf="cellId === 'directionCell'"
						  [tooltip]="item.direction === 'outbound' ? 'Outgoing email' : 'Incoming email'">
						<img [src]="item.direction === 'outbound' ? 'images/outbound-direction.png' : 'images/inbound-direction.png'"
							 style="width: 20px; height: 20px;"/>
					</span>


					<!--status cells-->
					<div *ngIf="cellId === 'statusCell'" class="flxRow-center hSpace1" style="align-items: center;">
						<i [ngClass]="item.status === 'Completed' ? 'far fa-check-circle' : item.status === 'Quarantined' ? 'far fa-bug' :  item.status === 'Failed' ? 'far fa-times-circle' : item.status === 'In Process' ? 'far fa-clock' : 'far fa-exclamation-triangle'"
						   [tooltip]="item.status"
						   [ngStyle]="{'color' : item.status === 'Completed' ? 'darkgreen' : item.status === 'Quarantined' || item.status === 'Failed' ? 'red' : 'grey'}"></i>
					</div>

					<!--subject header-->
					<div *ngIf="cellId === 'subjectHeader'" class="flxRow w100" style="align-items: center; width: 100%;">
						<span style="flex-shrink: 0;">Subject</span>
						<a class="flxRow animated fadeIn ellipsis" style="color: royalblue; font-weight: 400; padding: 5px 10px; flex: 1 0; align-items: center;"
						   dir="rtl"
						   *ngIf="activeSubjectAsFilter"
						   (click)="setSubjectAsFilter(''); $event.stopPropagation()">
							<i class="far fa-times" style="white-space: pre-wrap; padding: 5px;"></i>
							<span class="hvr-underline ellipsis" style="font-size: calc(0.7rem + 0.05vw);">
							   {{activeSubjectAsFilter}}
							</span>
						</a>
					</div>

					<!--sender header-->
					<div *ngIf="cellId === 'senderHeader'" class="flxRow w100" style="align-items: center; width: 100%;">
						<span style="flex-shrink: 0;">Sender</span>
						<a class="flxRow animated fadeIn ellipsis" style="color: royalblue; font-weight: 400; padding: 5px 10px; flex: 1 0; align-items: center;"
						   dir="rtl"
						   *ngIf="activeSenderAsFilter"
						   (click)="setSenderAsFilter(''); $event.stopPropagation()">
							<i class="far fa-times" style="white-space: pre-wrap; padding: 5px;"></i>
							<span class="hvr-underline ellipsis" style="font-size: calc(0.7rem + 0.05vw);">
							   {{activeSenderAsFilter}}
							</span>
						</a>
					</div>

					<!--recipient header-->
					<div *ngIf="cellId === 'recipientHeader'" class="flxRow w100" style="align-items: center; width: 100%;">
						<span style="flex-shrink: 0;">Recipient</span>
						<a class="flxRow animated fadeIn ellipsis" style="color: royalblue; font-weight: 400; padding: 5px 10px; flex: 1 0; align-items: center;"
						   dir="rtl"
						   *ngIf="activeRecipientAsFilter"
						   (click)="setRecipientAsFilter(''); $event.stopPropagation()">
							<i class="far fa-times" style="white-space: pre-wrap; padding: 5px;"></i>
							<span class="hvr-underline ellipsis" style="font-size: calc(0.7rem + 0.05vw);">
							   {{activeRecipientAsFilter}}
							</span>
						</a>
					</div>

					<!--message id header-->
					<div *ngIf="cellId === 'messageIdHeader'" class="flxRow w100" style=" align-items: center; width: 100%;">
						<span style="flex-shrink: 0;">Message ID</span>
						<a class="flxRow animated fadeIn ellipsis" style="color: royalblue; font-weight: 400; padding: 5px 10px; flex: 1 0; align-items: center;"
						   dir="rtl"
						   *ngIf="activeMessageIdAsFilter"
						   (click)="setMessageIdAsFilter(''); $event.stopPropagation()">
							<i class="far fa-times" style="white-space: pre-wrap; padding: 5px;"></i>
							<span class="hvr-underline ellipsis" style="font-size: calc(0.7rem + 0.05vw);">
							   {{activeMessageIdAsFilter}}
							</span>
						</a>
					</div>
				</ng-template>

				<ng-template #subRow let-item>
					<tr style="border-bottom: none;" *ngIf="item.isExpanded">
						<td colspan="9" style="background: white; border-bottom: solid 1px #e3e4e4; ">
							<div class="flxClmn vSpace05" style="padding: 10px 20px; cursor: default;">
								 <div class="flex-row gap-1" *ngFor="let message of item.text">
									<span class="flex-shrink-0" *ngIf="message.timestamp"><b>{{message.timestamp | date:'MM/dd/yyyy HH:mm:ss'}}</b>:</span>
									 <span *ngIf="message.log" style="white-space: normal;">{{message.log}}</span>
									 <img *ngIf="message.showMapIcon" (click)="openLocation(message.ll)" tooltip="Open in Google Maps" class="googleMaps" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACoFBMVEUAAADdSj7cSz7dSz7dSz7dSz7dSj7dSz7fTUDoRkbdSj3dSz7dSz7dSz7fQEDbSTfdSz7mTTPdSz7eSj43pWc0pmg0pmjdSz7eTD00pmndTD40pmjdSj7dSz7cTD3bTED/AADfSjzdTD7NU0PVVSuOooaQuaKYv6nI3dHW0lSz1cOXu27azGSrzNLdSz40pmhfj13cSz7cSz2fbE3bSj2kOTCDLiimOTFDrXNmvI1TtH84qGvEWUSvPDKALSezPTQ3p2qk17v8/v3////q9vBju4vRUUGaNS2dNy+X0bG74cx1w5mIy6a64cs+q3DBWkatOzKxPTNAq3H5/fu74c2jak3aSj2fOC+BLSiiODDbSj5huol5xJxYtoPk8+ux3cVgjl3ZSj3ZSj5UtICQzqxKsHmg1bmi1rr9/v2w3MQ1pWi4X0fV7ODv+PNct4Y2p2ma07SEyaNVr2TLxlTbTj5VtYHr9vD9/v7g8ejw+PTM6dk5qGxXr2Tr11H93E/HrVrG5tW/49CIy6dVrmTq11L83FHJi11asGPt2FHdz3rUVEbUVETu2FHq03TEw8GkpJJcsGP93FHq1XfDw8PCw8K9cWC9cV5dsWPv2FD178zs6+vExMSqtqqptanv2FHr6c7r6+u1fGlismLy2VHo5srs7OymsKFjs2Lz2VDAvHx3nM3w9Pru7u7FxcW/wsDWVEXWUkW+wsBks2O/vHxdicRciMV2m87v8/m1fmpls2Lz2lC+u311ms7u8/mqm4enl4O9u37u8vno6+iuu69rtGH22lC8un9diMR0mc3w8PDGxsZstWH32lC8uX9wl8zr8Pjx8fG1t4Rwlszq8PdttWG0toTp7/f12VCxtIevs4lvlsz+///821Ctsoro7vfy9vpSRSY7AAAALnRSTlMALYvN5+bKiCgLnv38lQgOxQquoSXG/P42w5T64suiQAE3h+IGpaquyPFuVvzMdTvKwAAAAAFiS0dEQ2fQDWIAAAAHdElNRQfiBQ0JLhcq1/DgAAACB0lEQVQ4y23Q+VtMUQDG8cMoW/YlZcm+d28pyV4Osu9LtiGRiOw7g4pBqbgRsmXJvneI7IRCpaJV/hXnPWea7h33/eWe53w/z8ydIcRkDRpaGrm5N25CzNe0WXNFzKNFS7PeyqI417qNCWir6NaOkPYdOqr6+cniP0Q8PDsRL9W4ANwHDg0KGuaPkzfpjNvg4SNGOsAoXI8ewzcWJwvhdyGh4ygdP0GCibgOA5iEUxeAyXTK1GnTZ0gwE9ezAGbj1JWDOXPn6d5hPq4XLAwPX7QYp24cLKFL1WVWq3W5ACvkr4hYKZ8+HETSVerqqDXRawVYF6P/H9y74x3Wb4hVN26imwXYsnVbfffoQQC279i5azfdsxd9337bgXrQkwigBkcdPBQnenyCzXb4SF3v1dsBnLMftfEdOy57Yh/iAuxJ6CeSUyRI6esCUtFPnkrW0k6jn0lzAeln0c+dz9C0CwAXNSNIv4R+mdIrXGQqSqZmBFev4fuvU74bGVqWomQZwc1b6Lfv3IW4d//Bw0ePDeCJ6E+z2bPnUuTkaHrw4iV6bjZj7NVrId681QPZ36Fz8R7iw0cd+JSH/vkLk/sqRH6BE3z7jv6jrjNWWARRXOAAsv9kupWUSiFAmei/mGElv4XoB1COXsFcVig+oz/AAN4r2X+r4p9RPRBg0OCaP8xkVbV/fdH/AbDMRR6RNRSkAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA1LTEzVDA5OjQ2OjIzKzAwOjAwGkGfCQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNS0xM1QwOTo0NjoyMyswMDowMGscJ7UAAAAASUVORK5CYII=" alt=""/>

									 <btn-c *ngIf="message.action" (action)="changeRecipientStatus(null, message.recipientObj)">{{message.recipientObj.is_blocked ? 'Unblock recipient' : 'Block recipient'}}</btn-c>
								</div>
							</div>
						</td>
					</tr>
				</ng-template>

				<div tableButtons>
					<ng-container [ngTemplateOutlet]="queryEl"></ng-container>
				</div>
			</trustifi-table-c>
		</div>
	</div>

	<popup-c *ngIf="previewEmailContentPopup?.show"
			 head="Preview Email" size="large"
			 (closeCb)="previewEmailContentPopup = null">
		<div class="flex-column f-1-0 gap-3" style="overflow: auto;">
			<div class="flex-row centralize f-1-0 hide-when-empty-force">
				<loader class="opacity-75" *ngIf="previewEmailContentPopup.getEmailContentInProcess"></loader>
				<span class="text-danger" *ngIf="previewEmailContentPopup.error">Error: {{previewEmailContentPopup.error}}</span>
			</div>
			<div class="flxRow-start hvr-opacity hSpace05 animated fadeIn" style="align-items: center; align-self: flex-end; cursor: pointer;"
				 *ngIf="previewEmailContentPopup.emailContent"
				 (click)="downloadEml(previewEmailContentPopup)">
				<i class="far fa-save" style="font-size: 1.2rem;"></i>
				<span style="font-size: 0.9rem;">Download as EML</span>
			</div>
			<email-viewer class="animated fadeIn" style="overflow: auto; flex: 1 0; width: 100%; min-width: 220px; border: 1px solid #ccc;"
						  [content]="previewEmailContentPopup.processedHtml"
						  *ngIf="previewEmailContentPopup.processedHtml"></email-viewer>
			<div class="flex-row gap-3 align-items-center overflow-auto f-1-0" style="max-height: 66px;"
				 *ngIf="previewEmailContentPopup.emailContent?.attachments?.length">
				<span>Attachments:</span>
				<div class="flex-row justify-content-start flex-wrap f-1-0 overflow-auto mh-100">
					<ng-container *ngFor="let file of previewEmailContentPopup.emailContent.attachments">
						<attachment-c
							[attName]="file.name"
							[attSize]="file.size"
							(preview)="previewAttachment = file;"
							(download)="downloadAttachment(file.content, file.name, file.type)">
						</attachment-c>
					</ng-container>
				</div>
			</div>
		</div>
	</popup-c>

	<popup-c class="bs-enabled no-content-padding"
			 *ngIf="outboundEmailAnalysisPopup?.show"
			 head="Outbound Analysis" size="large"
			 subTitle="Mailbox: <b>{{outboundEmailAnalysisPopup.emailObj?.from}}</b>"
			 width="1550px"
			 (closeCb)="outboundEmailAnalysisPopup = null">
		<div class="d-flex centralize f-1-0" *ngIf="outboundEmailAnalysisPopup.loading">
			<loader height="100" width="100" style="opacity: 0.8;"></loader>
		</div>
		<div class="flxRow h100 animated fadeIn" style="flex: 1 0; overflow: auto;" *ngIf="!outboundEmailAnalysisPopup.loading">
			<!--Sidebar-->
			<div class="flxClmn tp-popup-sidebar" style="max-width: 230px; box-shadow: 0 0 5px grey; overflow: hidden; background: linear-gradient(45deg, #d9efff75, white); position: sticky; left: 0; top: 0; z-index: 50;">
				<div class="flxClmn" style="padding: max(1.2vw,15px);">
					<span style="font-family: 'Roboto Condensed', sans-serif; font-size: 1.1rem;">Email Actions</span>
					<div style="background: linear-gradient(90deg, #9b9b9b, transparent); width: 100%; height: 1px; margin-bottom: min(15px,1vh);"></div>
					<div class="flxRow" style="flex-wrap: wrap;">
						<btn-c class="quarantined-popup-action-btn f-1-0" style="min-width: 52%; max-width: unset;"
							   *ngIf="outboundEmailAnalysisPopup.recipientObj?.canBlock"
							   (action)="changeRecipientStatus(outboundEmailAnalysisPopup.emailObj, outboundEmailAnalysisPopup.recipientObj)">
							{{outboundEmailAnalysisPopup.recipientObj.is_blocked ? 'Unblock recipient' : 'Block recipient'}}
						</btn-c>
						<btn-c class="quarantined-popup-action-btn f-1-0" style="min-width: 52%; max-width: unset;"
							   (action)="selectEmailAction(outboundEmailAnalysisPopup.emailObj, 'Resend email')">
							Resend Email
						</btn-c>
						<btn-c class="quarantined-popup-action-btn f-1-0" style="min-width: 52%; max-width: unset;"
							   (action)="selectEmailAction(outboundEmailAnalysisPopup.emailObj, 'Remove email')">
							Remove Email
						</btn-c>
					</div>
				</div>
			</div>

			<!--Cards grid-->
			<div class="flxClmn" style="flex: 1 0;">
				<div class="threat-protection-grid h100" style="flex: 1 0; overflow: auto !important; padding: 0 1.75vw !important; grid-auto-rows: 1fr; min-height: 550px;">
					<!--Sensitivity Analysis card-->
					<div *ngIf="outboundEmailAnalysisPopup?.sensitivity?.sensitive_types?.length"
						 class="threat-protection-card flxClmn f-1-0 co12 ro12" style="z-index: 5; overflow: auto; min-height: 400px;">
						<div class="card-header flxRow-between" style="align-items: center;">
							<span class="card-title">Sensitivity Analysis</span>
						</div>
						<div class="flex-column" style="flex: 1 0; overflow: auto; padding: 15px;">
							<trustifi-table-c
								class="trustifi-table" style="flex: 1 0; z-index: 5; min-height: 250px;"
								[list]="outboundEmailAnalysisPopup?.sensitivity?.sensitive_types"
								[headers]="[
									{text: 'Type', sortKey: 'sensitive_type'},
									{text: 'Score', sortKey: 'score', width: '70px'},
									{text: 'Content'},
									{text: 'Compliance'},
								]"
								[cellsPrototype]="[
									{textKey: 'sensitive_type'},
									{textKey: 'score'},
									{html: 'sensitivityContentCell'},
									{html: 'sensitivityComplianceCell'},
								]"
								[options]="{
									isEllipsis: false,
									itemsNameSingular: 'type',
								}"
							>
								<ng-template #customCells let-item let-cellId="cellId">
									<div *ngIf="cellId === 'sensitivityContentCell'">
										<div class="px-2 py-1 border rounded-1 flex-row gap-2">
											<input class="f-1-0 border-0 p-0 h-auto" style="font-size: 12px; background: inherit;"
												   type="{{!item.showSensitiveContent ? 'password':'text'}}"
												   [ngStyle]="{'letter-spacing' : item.showSensitiveContent ? 'normal' : '2.4px'}"
												   [ngClass]="{'nofill': !item.showSensitiveContent}"
												   [ngModel]="item.content" disabled>

											<ng-container *ngIf="outboundEmailAnalysisPopup.recipientObj?.viewContentPermission">
												<label class="hidepwd hvr-opacity" style="margin-bottom: 0; cursor: pointer; color: #676767;"
													   tooltip="{{item.showSensitiveContent ? 'Hide sensitive content' : 'Show sensitive content'}}">
													<input type="checkbox" [(ngModel)]="item.showSensitiveContent"/>
													<i class="fas fa-eye unchecked" ></i>
													<i class="fas fa-eye-slash checked"></i>
												</label>
												<i tooltip="Copy" class="far fa-copy copy-link" style="cursor: pointer; color: #676767;" (click)="gs.copyToClipboard(item.content);"></i>
											</ng-container>
										</div>
									</div>

									<div *ngIf="cellId === 'sensitivityComplianceCell'">
										<div class="value flex-row gap-2 justify-content-start flex-wrap">
										<span class="p-1 rounded-1 bg-dark bg-opacity-10"
											  *ngFor="let compliance of item.compliance" >
											{{compliance}}
										</span>
										</div>
									</div>
								</ng-template>

								<div tableButtons>
									<div class="flex-row p-1 rounded-1 align-items-center gap-1" style="border: 1px solid; width: 150px;"
										 [ngStyle]="outboundEmailAnalysisPopup?.sensitivity?.score === 0 && {'background-color':'#32cd324d', 'border-color':'limegreen'} || outboundEmailAnalysisPopup?.sensitivity?.score < 4 && {'background-color':'#ff8c004d', 'border-color':'darkorange'} || outboundEmailAnalysisPopup?.sensitivity?.score < 5 && {'background-color':'#FF851B4d', 'border-color':'#FF851B'} || outboundEmailAnalysisPopup?.sensitivity?.score === 5 && {'background-color':'#FF41364d', 'border-color':'#FF4136' }">
										<div class="header">Sensitivity Score:</div>
										<input type="button" value="{{outboundEmailAnalysisPopup?.sensitivity?.score}}"
											   [ngStyle]="outboundEmailAnalysisPopup?.sensitivity?.score === 0 && {'background':'limegreen'} || outboundEmailAnalysisPopup?.sensitivity?.score < 4 && {'background':'darkorange'} || outboundEmailAnalysisPopup?.sensitivity?.score < 5 && {'background':'#FF851B'} || outboundEmailAnalysisPopup?.sensitivity?.score === 5 && {'background':'#FF4136'}"
											   class="redborder" style="cursor: unset; width: 25px; margin: 0; padding-top: 4px; padding-bottom: 4px; border: 0; color: white !important;"
											   tooltip="Reflects how sensitive the content found in the email is on a scale of 0 (not sensitive) to 5 (extremely sensitive)" placement="right">
									</div>
								</div>
							</trustifi-table-c>
						</div>
					</div>

					<!--Email Content card-->
					<div class="threat-protection-card flxClmn f-1-0 co12 ro24" style="overflow: auto;"
						 [style.order]="outboundEmailAnalysisPopup?.sensitivity?.sensitive_types?.length ? 'unset' : '1'"
						 *ngIf="outboundEmailAnalysisPopup.recipientObj.viewContentPermission">
						<div class="card-header flxRow-between" style="align-items: center;">
							<span class="card-title">Email Content</span>
							<div class="flxRow hSpace1" [ngClass]="{'disabled' : !outboundEmailAnalysisPopup.emailContent}">
								<a>
									<i class="far fa-solid fa-code" style="font-size: 1rem;" tooltip="View source"
									   (click)="outboundEmailAnalysisPopup.showHtml = !outboundEmailAnalysisPopup.showHtml"></i>
								</a>
								<a>
									<i class="far fa-download" tooltip="Download email as EML" style="font-size: 1rem;"
									   (click)="downloadEml(outboundEmailAnalysisPopup)"></i>
								</a>
							</div>
						</div>
						<div class="flxClmn vSpace05" style="flex: 1 0; overflow: auto; padding: 15px 20px 10px;">
							<div class="flex-column f-1-0 gap-3" style="overflow: auto; min-width: 220px; position: relative;">
								<div style="flex: 1 0; overflow: auto;" class="flxClmn">
									<email-viewer [content]="outboundEmailAnalysisPopup.processedHtml" style="min-height: 100%;"
												  *ngIf="!outboundEmailAnalysisPopup.showHtml && outboundEmailAnalysisPopup.processedHtml"></email-viewer>
									<div class="flxClmn" style="flex: 1 0;" *ngIf="outboundEmailAnalysisPopup.showHtml">
										<pre style="white-space: normal; word-break: break-word;">{{this.outboundEmailAnalysisPopup.emailContent?.html || this.outboundEmailAnalysisPopup.emailContent?.text}}</pre>
									</div>
								</div>
								<div class="flex-row gap-3 align-items-center overflow-auto f-1-0" style="max-height: 66px;"
									 *ngIf="outboundEmailAnalysisPopup.emailContent?.attachments?.length">
									<span>Attachments:</span>
									<div class="flex-row justify-content-start flex-wrap f-1-0 overflow-auto mh-100">
										<ng-container *ngFor="let file of outboundEmailAnalysisPopup.emailContent.attachments">
											<attachment-c
												[attName]="file.name"
												[attSize]="file.size"
												(preview)="previewAttachment = file;"
												(download)="downloadAttachment(file.content, file.name, file.type)">
											</attachment-c>
										</ng-container>
									</div>
								</div>
								<btn-c class="absolute-centralize"
									   *ngIf="outboundEmailAnalysisPopup.getEmailContentInProcess !== false"
									   [loading]="outboundEmailAnalysisPopup.getEmailContentInProcess"
									   (action)="getOutboundEmailContent()">
									Show Email Content
								</btn-c>
							</div>
						</div>
					</div>

					<!--Tracking Events card-->
					<div *ngIf="outboundEmailAnalysisPopup?.recipientObj?.track_events?.length"
						 class="threat-protection-card flxClmn co12 ro12" style="z-index: 4; overflow: auto; min-height: 370px;">
						<div class="card-header flxRow-between" style="align-items: center;">
							<span class="card-title">Tracking Events</span>
						</div>

						<div class="flex-row gap-5" style="align-items: center; margin-bottom: 2rem; padding: 10px;">
							<ng-container *ngFor="let event of outboundEmailAnalysisPopup.trackingEvents">
								<div class="flex-column align-items-center tracking-icn-container"
								     [ngClass]="{'active': outboundEmailAnalysisPopup.getTrackingStatus(event.name) === 'success',
							 'current': outboundEmailAnalysisPopup.getTrackingStatus(event.name) === 'failed' || event.name === 'Blocked',
							 'not-active': outboundEmailAnalysisPopup.getTrackingStatus(event.name) === 'none'}">
									<div class="tracking-icon" [ngClass]="{'first': event.isFirst, 'last': event.isLast}">
										<i class="{{ event.icon }}"></i>
									</div>
									<span>{{ event.label }}</span>
								</div>
							</ng-container>

							<ng-template #trackingTemplate let-event="event">
								<div class="flex-column align-items-center tracking-icn-container"
								     [ngClass]="{'active': outboundEmailAnalysisPopup.getTrackingStatus(event.name) === 'success',
							 'current': outboundEmailAnalysisPopup.getTrackingStatus(event.name) === 'failed' || event.name === 'Blocked',
							 'not-active': outboundEmailAnalysisPopup.getTrackingStatus(event.name) === 'none'}">
									<div class="tracking-icon" [ngClass]="{'first': event.isFirst, 'last': event.isLast}">
										<i class="{{ event.icon }}"></i>
									</div>
									<span>{{ event.label }}</span>
								</div>
							</ng-template>
						</div>

						<div class="flex-column" style="flex: 1 0; overflow: auto; padding: 15px;">
							<trustifi-table-c class="trustifi-table f-1-0" style="z-index: 4; min-height: 200px;"
								  [list]="outboundEmailAnalysisPopup?.recipientObj?.track_events"
								  [headers]="[
									{text: 'Created', sortKey: 'created', width: '150px'},
									{text: 'Event', sortKey: 'name', width: '175px'},
									{text: 'Description'}
								  ]"
								  [cellsPrototype]="[
									{textKey: 'created', textType: 'dateAndTime'},
									{html: 'nameCell'},
									{html: 'infoCell'}
								  ]"
								  [options]="{
									hideCounter: true,
									defaultSortKey: '-created',
								}">

								<ng-template #customCells let-item let-cellId="cellId">
									<!--name cell-->
									<div *ngIf="cellId === 'nameCell'">
										<div class="flex-row hSpace05" [ngStyle]="item.ll ? {'align-items' : 'end'} : {}">
											<span>{{item.name}}</span>
											<img *ngIf="(item.name == 'Read' || item.name == 'Opened') && item.ll" (click)="openLocation(item.ll)" title="Open in Google Maps" class="googleMaps" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACoFBMVEUAAADdSj7cSz7dSz7dSz7dSz7dSj7dSz7fTUDoRkbdSj3dSz7dSz7dSz7fQEDbSTfdSz7mTTPdSz7eSj43pWc0pmg0pmjdSz7eTD00pmndTD40pmjdSj7dSz7cTD3bTED/AADfSjzdTD7NU0PVVSuOooaQuaKYv6nI3dHW0lSz1cOXu27azGSrzNLdSz40pmhfj13cSz7cSz2fbE3bSj2kOTCDLiimOTFDrXNmvI1TtH84qGvEWUSvPDKALSezPTQ3p2qk17v8/v3////q9vBju4vRUUGaNS2dNy+X0bG74cx1w5mIy6a64cs+q3DBWkatOzKxPTNAq3H5/fu74c2jak3aSj2fOC+BLSiiODDbSj5huol5xJxYtoPk8+ux3cVgjl3ZSj3ZSj5UtICQzqxKsHmg1bmi1rr9/v2w3MQ1pWi4X0fV7ODv+PNct4Y2p2ma07SEyaNVr2TLxlTbTj5VtYHr9vD9/v7g8ejw+PTM6dk5qGxXr2Tr11H93E/HrVrG5tW/49CIy6dVrmTq11L83FHJi11asGPt2FHdz3rUVEbUVETu2FHq03TEw8GkpJJcsGP93FHq1XfDw8PCw8K9cWC9cV5dsWPv2FD178zs6+vExMSqtqqptanv2FHr6c7r6+u1fGlismLy2VHo5srs7OymsKFjs2Lz2VDAvHx3nM3w9Pru7u7FxcW/wsDWVEXWUkW+wsBks2O/vHxdicRciMV2m87v8/m1fmpls2Lz2lC+u311ms7u8/mqm4enl4O9u37u8vno6+iuu69rtGH22lC8un9diMR0mc3w8PDGxsZstWH32lC8uX9wl8zr8Pjx8fG1t4Rwlszq8PdttWG0toTp7/f12VCxtIevs4lvlsz+///821Ctsoro7vfy9vpSRSY7AAAALnRSTlMALYvN5+bKiCgLnv38lQgOxQquoSXG/P42w5T64suiQAE3h+IGpaquyPFuVvzMdTvKwAAAAAFiS0dEQ2fQDWIAAAAHdElNRQfiBQ0JLhcq1/DgAAACB0lEQVQ4y23Q+VtMUQDG8cMoW/YlZcm+d28pyV4Osu9LtiGRiOw7g4pBqbgRsmXJvneI7IRCpaJV/hXnPWea7h33/eWe53w/z8ydIcRkDRpaGrm5N25CzNe0WXNFzKNFS7PeyqI417qNCWir6NaOkPYdOqr6+cniP0Q8PDsRL9W4ANwHDg0KGuaPkzfpjNvg4SNGOsAoXI8ewzcWJwvhdyGh4ygdP0GCibgOA5iEUxeAyXTK1GnTZ0gwE9ezAGbj1JWDOXPn6d5hPq4XLAwPX7QYp24cLKFL1WVWq3W5ACvkr4hYKZ8+HETSVerqqDXRawVYF6P/H9y74x3Wb4hVN26imwXYsnVbfffoQQC279i5azfdsxd9337bgXrQkwigBkcdPBQnenyCzXb4SF3v1dsBnLMftfEdOy57Yh/iAuxJ6CeSUyRI6esCUtFPnkrW0k6jn0lzAeln0c+dz9C0CwAXNSNIv4R+mdIrXGQqSqZmBFev4fuvU74bGVqWomQZwc1b6Lfv3IW4d//Bw0ePDeCJ6E+z2bPnUuTkaHrw4iV6bjZj7NVrId681QPZ36Fz8R7iw0cd+JSH/vkLk/sqRH6BE3z7jv6jrjNWWARRXOAAsv9kupWUSiFAmei/mGElv4XoB1COXsFcVig+oz/AAN4r2X+r4p9RPRBg0OCaP8xkVbV/fdH/AbDMRR6RNRSkAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA1LTEzVDA5OjQ2OjIzKzAwOjAwGkGfCQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNS0xM1QwOTo0NjoyMyswMDowMGscJ7UAAAAASUVORK5CYII=" alt=""/>
										</div>
									</div>
									<!--Info cell-->
									<div *ngIf="cellId === 'infoCell'">
										<ul style="list-style: none; padding-left: 0; margin: 0;">
											<li *ngFor="let event of item.info;" style="font-size: 12px;">{{event.msg}}</li>
										</ul>
									</div>
								</ng-template>

								<div tableButtons>
									<span>Recipient Track Events</span>
								</div>
							</trustifi-table-c>
						</div>
					</div>

				</div>
			</div>

		</div>
	</popup-c>


	<attachment-preview
		*ngIf="previewAttachment"
		[attachment]="previewAttachment"
		(onClose)="previewAttachment = null;">
	</attachment-preview>

	<quarantined-email-action
		*ngIf="quarantinedEmailAction"
		[action]="quarantinedEmailAction.action"
		[email]="quarantinedEmailAction.email"
		[data]="quarantinedEmailAction.data"
		[planInfo]="quarantinedPlanInfo"
		(doneCb)="quarantinedEmailAction = null;">
	</quarantined-email-action>
</div>
